import { type MakeRouteMatchUnion } from "@tanstack/react-router";
import { type FileRoutesId } from "~/utils/types";

export const isEndMatch = (
  matches: MakeRouteMatchUnion[],
  routeId: FileRoutesId,
): boolean => matches[matches.length - 1]?.routeId === routeId;
